import createIcon from '../../createIcon';

/**
 * @component @name SmartButton
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgOFYxNEMyMiAxNS4xIDIxLjEgMTYgMjAgMTZIMTlWMTRIMjBWOEg0VjE0SDEwVjE2SDRDMi45IDE2IDIgMTUuMSAyIDE0VjhDMiA2LjkgMi45IDYgNCA2SDIwQzIxLjEgNiAyMiA2LjkgMjIgOFpNMTQuNSAxOEwxNS41OSAxNS41OUwxOCAxNC41TDE1LjU5IDEzLjQxTDE0LjUgMTFMMTMuNDEgMTMuNDFMMTEgMTQuNUwxMy40MSAxNS41OUwxNC41IDE4Wk0xNyAxM0wxNy42MiAxMS42MkwxOSAxMUwxNy42MiAxMC4zOEwxNyA5TDE2LjM4IDEwLjM4TDE1IDExTDE2LjM4IDExLjYyTDE3IDEzWk0xNC41IDE4TDE1LjU5IDE1LjU5TDE4IDE0LjVMMTUuNTkgMTMuNDFMMTQuNSAxMUwxMy40MSAxMy40MUwxMSAxNC41TDEzLjQxIDE1LjU5TDE0LjUgMThaTTE3IDEzTDE3LjYyIDExLjYyTDE5IDExTDE3LjYyIDEwLjM4TDE3IDlMMTYuMzggMTAuMzhMMTUgMTFMMTYuMzggMTEuNjJMMTcgMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SmartButton = createIcon('SmartButton', [
  [
    'path',
    {
      d: 'M22 8V14C22 15.1 21.1 16 20 16H19V14H20V8H4V14H10V16H4C2.9 16 2 15.1 2 14V8C2 6.9 2.9 6 4 6H20C21.1 6 22 6.9 22 8ZM14.5 18L15.59 15.59L18 14.5L15.59 13.41L14.5 11L13.41 13.41L11 14.5L13.41 15.59L14.5 18ZM17 13L17.62 11.62L19 11L17.62 10.38L17 9L16.38 10.38L15 11L16.38 11.62L17 13ZM14.5 18L15.59 15.59L18 14.5L15.59 13.41L14.5 11L13.41 13.41L11 14.5L13.41 15.59L14.5 18ZM17 13L17.62 11.62L19 11L17.62 10.38L17 9L16.38 10.38L15 11L16.38 11.62L17 13Z',
      key: '1flsuo',
    },
  ],
]);

export default SmartButton;
